import classNames from 'classnames'
import React from 'react'

const ValidationMessage: React.FunctionComponent<ValidationMessageProps> = props => {
  const { wrapElement, positioned, children } = props
  const className = classNames(
    'Validation-message',
    positioned && 'Validation-message--positioned',
  )
  return React.createElement(wrapElement, { className }, children)
}
ValidationMessage.defaultProps = {
  wrapElement: 'div',
  positioned: true,
}

type ValidationMessageProps = {
  wrapElement?: string,
  positioned?: boolean,
  children: React.ReactNode,
}

export default ValidationMessage
